import React from 'react';
import Helmet from 'react-helmet';
import { Grid, Button, Tooltip, LinearProgress } from '@material-ui/core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import InfoSquareBlack from 'assets/icons/info-square-black.svg';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import Box from 'retired/Box';
import Img from 'retired/Img';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';
import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import ReportsPageBanner from 'assets/pageBanners/reports.avif';

import { useAvailableReportDefinitions } from './hooks';

const ReportsPage: React.FC = () => {
  const user = useSelector(selectUser);
  const history = useHistory();
  const organization = useSelector(selectOrganization);
  const { reportDefinitions, loading } = useAvailableReportDefinitions(organization?.name || '');

  if (
    user &&
    (!user.hasFeature(Features.ADVANCED_REPORTING) ||
      !(
        user.hasPrivilege(Privileges.REPORTS_VIEW) ||
        user.hasPrivilege(Privileges.REPORTS_VIEW_RESTRICTED)
      ))
  ) {
    history.replace('/');
  }

  return (
    <>
      <Helmet title="Reports" />
      <PageBannerContainer color="#FFE5B4" backgroundImage={ReportsPageBanner}>
        <Tooltip
          placement="right"
          title="Optimized for Excel users, please reach out to your Partner Success Manager if you use other tools"
        >
          <div style={{ display: 'flex', width: 'fit-content' }}>
            <h1>Reports</h1>
            <Img
              src={InfoSquareBlack}
              alt="Reports"
              style={{
                height: 'max-content',
                margin: '25px 10px',
              }}
            />
          </div>
        </Tooltip>
      </PageBannerContainer>

      {loading ? (
        <LinearProgress />
      ) : (
        <Grid container>
          {reportDefinitions.map((item) => (
            <Grid item lg={4} md={6} sm={12} key={`${item.icon}`} style={{ padding: 10 }}>
              <Box style={{ height: 260 }}>
                <Img src={item.icon} width={42} height={42} alt={item.title || ''} />
                <h4>{item.title}</h4>
                <p style={{ fontSize: 14, letterSpacing: -0.3 }}>{item.text}</p>
                <Link to={`/reports/${item.type}`}>
                  <Button
                    color="primary"
                    type="button"
                    endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
                  >
                    View
                  </Button>
                </Link>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default ReportsPage;
